export class Model_ClientType
    {
        ClientId : number;
        ClientTypeval : string;

    }